var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:[{ active: _vm.isActive }, _vm.teamType.toLowerCase()],domProps:{"textContent":_vm._s(_vm.teamType)},on:{"click":function($event){return _vm.selectTeamTypeToCreate(_vm.teamType)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }